// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Rc-B","messages":"Chat_messages__12vTw","dateDivider":"Chat_dateDivider__3pFTd"};